// src/features/owner/sections/content/MediaLibrarySection.tsx
import { useTheme } from 'styled-components';
import { useOwnerMedia } from '@/hooks';
import { MetaRow } from '@/ui';
import { OwnerPanel, EmptyState } from '../../components';

function fmtBytes(b: number) {
  return b > 1e6 ? `${(b / 1e6).toFixed(1)} MB` : `${(b / 1e3).toFixed(0)} KB`;
}

export function MediaLibrarySection() {
  const theme = useTheme();
  const { data, loading, error } = useOwnerMedia();

  if (loading) return <p style={{ opacity: 0.6 }}>Loading…</p>;
  if (error || !data) return <EmptyState icon="image" message={error ?? 'No data'} />;

  return (
    <OwnerPanel
      title={
        <MetaRow>
          {`Media Library: ${data.totals.count} items`}
          {fmtBytes(data.totals.bytes)}
        </MetaRow>
      }
    >
      {data.items.length === 0 ? (
        <EmptyState icon="image" message="No media uploaded yet" />
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill,minmax(120px,1fr))',
            gap: 10,
          }}
        >
          {data.items.map((m) => (
            <div
              key={m.id}
              style={{
                border: `1px solid ${theme.color.glassBorder}`,
                borderRadius: 10,
                padding: 8,
                fontSize: 11,
              }}
            >
              <div style={{ opacity: 0.6 }}>{m.kind || 'file'}</div>
              <div style={{ wordBreak: 'break-all' }}>{m.key}</div>
              <div style={{ opacity: 0.6 }}>{fmtBytes(m.bytes)}</div>
            </div>
          ))}
        </div>
      )}
    </OwnerPanel>
  );
}
